/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Markdown from 'bundles/cms/components/Markdown';

type Props = {
  stats?: string | null;
};

const style = {
  markdown: css`
    white-space: pre-wrap;
  `,
};

const CareerCardDescription: React.FC<Props> = ({ stats }) => {
  return (
    <div css={style.markdown}>
      <Markdown source={stats} />
    </div>
  );
};

export default CareerCardDescription;
